import { render, staticRenderFns } from "./multiplePosition.vue?vue&type=template&id=053e2473&"
import script from "./multiplePosition.vue?vue&type=script&lang=ts&"
export * from "./multiplePosition.vue?vue&type=script&lang=ts&"
import style0 from "./multiplePosition.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports